export default __webpack_public_path__ + "media/images/features/saga/illustrations_right-1dd449e18a226827ea86cbd043d7ee2d.png";